import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { SectionHeading } from "./Reveal";
import { useLanguage } from "@/context/LanguageContext";

const Markets = () => {
  const { t } = useLanguage();

  const marketsList = [
    { icon: "Store", title: t("markets.m1") },
    { icon: "Handshake", title: t("markets.m2") },
    { icon: "Boxes", title: t("markets.m3") },
    { icon: "ShoppingCart", title: t("markets.m4") },
    { icon: "UtensilsCrossed", title: t("markets.m5") },
    { icon: "Ship", title: t("markets.m6") },
    { icon: "User", title: t("markets.m7") },
  ];

  return (
    <section id="markets" className="relative py-24 md:py-36 bg-[#f8fff8]" data-testid="markets-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading
          eyebrow={t("markets.eyebrow")}
          title={`${t("markets.title")} ${t("markets.titleHighlight")}`}
          subtitle={t("markets.subtitle")}
          testid="markets"
          align="center"
        />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 mt-16">
          {marketsList.map((m, i) => {
            const Icon = Icons[m.icon] || Icons.Store;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.55, delay: (i % 4) * 0.07 }}
                whileHover={{ y: -5 }}
                className="group rounded-3xl border border-[#95d5b2]/40 bg-white hover:border-[#40916c]/40 p-7 flex flex-col items-start gap-5 transition-all shadow-sm hover:shadow-md"
                data-testid={`market-card-${i}`}
              >
                <div className="h-14 w-14 rounded-2xl bg-[#d8f3dc] text-[#2d6a4f] group-hover:bg-[#40916c] group-hover:text-white flex items-center justify-center transition-colors">
                  <Icon size={24} strokeWidth={1.8} />
                </div>
                <div>
                  <h3 className="font-display text-lg font-semibold text-[#222222]">
                    {m.title}
                  </h3>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Markets;
